import { debounce } from "lodash-es";
import { ReactNode } from "react";
import tw from "src/utils/tw";
import { useMediaQueries } from "src/utils/useMediaQueries";
import { VList, WindowVirtualizer } from "virtua";

interface Props {
  rows: any[];
  renderRow: (item, index) => any;
  onEndReached?: (rows: any[]) => void;
  className?: string;
  loading?: boolean;
  emptyMessage?: string | ReactNode;
  scrollKey?: string;
  scrollOffset?: number;
  triggerOnNoScroll?: boolean;
  children?: ReactNode;
  window?: boolean;
}

export function VirtualList(props: Props) {
  const { small } = useMediaQueries();
  const onBottom = debounce(() => {
    if (props.onEndReached) {
      props.onEndReached(props.rows);
    }
  }, 500);

  if (props.rows?.length === 0 && !props.loading) {
    return (
      <div
        className={tw(
          "container-type-size overflow-auto sm:h-full md:pb-14",
          props.className
        )}
      >
        <div className="p-4 text-sm text-empty">
          <strong>
            {typeof props.emptyMessage !== "undefined"
              ? props.emptyMessage
              : "No items to display."}
          </strong>
        </div>
      </div>
    );
  }

  const content = props.rows.map((item, index) => props.renderRow(item, index));

  if (small || props.window) {
    return (
      <div className={props.className}>
        <WindowVirtualizer onScrollEnd={onBottom}>{content}</WindowVirtualizer>
      </div>
    );
  }

  return (
    <>
      <VList className={props.className} onScrollEnd={onBottom}>
        {content}
      </VList>
    </>
  );
}
